import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiClientConstant, RequestQueryPayload, Table } from '@cureskin/api-client';
import { ConnectionService } from '../../services/connection-service';
import { AppConfig } from '../../app/app.config';
import { Broadcaster } from '../broadcaster';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, filter, mergeMap, Observable } from 'rxjs';

@Component({
    selector: 'change-allocated-doctor',
    templateUrl: './change-allocated-doctor.html',
    standalone: false
})
export class ChangeAllocatedDoctor {
  selectedDoctor: any;
  public autoCompleteDoctorController: UntypedFormControl = new UntypedFormControl();
  doctorOptions: Observable<Array<{ name: string; object: any }>>;
  type: string;
  label: string;
  allocatedTeamType: Array<any>;
  constructor(
    private dialogRef: MatDialogRef<ChangeAllocatedDoctor>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private conn: ConnectionService,
    private broadcaster: Broadcaster,
    public appConfig: AppConfig) { }

  async ngOnInit(): Promise<void> {
    this.type = this.data.type;
    this.allocatedTeamType = [
      { display: 'MBBS', value: 'MBBS' },
      { display: 'DERMATOLOGIST', value: 'DERMATOLOGIST' },
    ];
    this.doctorOptions = this.autoCompleteDoctorController.valueChanges
    .pipe(
      debounceTime(300),
      filter((token: string) => !!token.length),
      mergeMap((token: string) => this.getDoctors(token)),
    );
  }

  async getDoctors(token: string): Promise<Array<{ name: string; object: any }>> {
    const payload: RequestQueryPayload<Table.User> = {
      where: {
        $or: [
          {
            username: { $regex: token, $options: 'i' },
          },
          {
            DoctorDisplayName: { $regex: token, $options: 'i' },
          },
        ],
        type: { $in: [ApiClientConstant.User.Type.DOCTOR] },
        inactive: false,
      },
      project: ['username', 'DoctorDisplayName', 'knownLanguages'],
      limit: 5,
    };
    const doctors = await this.conn.findUsers(payload);
    const formattedDoctors = doctors.map((doctor: any): { name: string; object: any } => ({
      name: doctor.get('DoctorDisplayName'),
      object: doctor,
    }));
    return formattedDoctors;
  }

  autoCompleteOnDoctorSelect(option: { name: string; object: any }): void {
    this.selectedDoctor = option.object;
    this.autoCompleteDoctorController.setValue('');
  }

  async save(): Promise<void> {
    let updatedRecords: Array<Table.Order | Table.FollowUp> = [];
    if (this.type === this.appConfig.Shared.AllocatedDoctorPopup.Type.ORDER) {
      updatedRecords = this.data.approvalList.map((id: string) => {
        const order = new Table.Order();
        order.id = id;
        if (this.selectedDoctor) {
          order.set('allocatedDoctor', this.selectedDoctor);
        }
        return order;
      });
    } else {
      updatedRecords = this.data.followUpList.map((id: string) => {
        const followup = new Table.FollowUp();
        followup.id = id;
        if (this.selectedDoctor) {
          followup.set('allocatedDoctor', this.selectedDoctor);
        }
        if (this.label) {
          followup.set('allocatedTeam', this.label);
        }
        return followup;
      });
    }

    try {
      this.conn.saveAll(updatedRecords);
      this.broadcaster.broadcast('NOTIFY', {
        message: `${this.type} Allocated Successfully`,
        type: this.appConfig.Shared.Toast.Type.SUCCESS,
      });
      this.dialogRef.close(this.selectedDoctor || this.label);
    } catch (error) {
      this.broadcaster.broadcast('NOTIFY', {
        message: error.message || error,
        type: this.appConfig.Shared.Toast.Type.ERROR,
      });
    }
  }

  hideModal(): void {
    this.dialogRef.close();
  }
}
